// tslint:disable
/// <reference path="../custom.d.ts" />
/**
 * Reposit API
 * The Reposit API
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
import { Configuration } from '../configuration';
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';

import { RemoveTenancyOrderDTO } from '../models';
import { ReopenRepositDTO } from '../models';
import { SearchTenancyOrderResultsDTO } from '../models';
import { TenancyOrderWithTenancyAndOrderCustomersDTO } from '../models';
import { TransferTenancyOrderDTO } from '../models';
/**
 * TenancyOrdersApi - axios parameter creator
 * @export
 */
export const TenancyOrdersApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Get a Tenancy Order By Id
         * @param {string} id Tenancy Order Id
         * @param {boolean} [includeDeleted] Include deleted
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTenancyOrderById(id: string, includeDeleted?: boolean, options: any = {}): RequestArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling getTenancyOrderById.');
            }
            const localVarPath = `/v2/tenancy-orders/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = new URL(localVarPath, 'http://placeholder');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (includeDeleted !== undefined) {
                localVarQueryParameter['includeDeleted'] = includeDeleted;
            }


    
            Object.entries({...localVarQueryParameter, ...options.query}).forEach(([key, value]) => {
                if (value !== undefined) {
                    localVarUrlObj.searchParams.set(key, String(value));
                }
            });
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search,
                options: localVarRequestOptions,
            };
        },
        /**
         * Optimised search for a tenancy order via address, landlord and tenants
         * @param {string} organizationId Organization Id to filter to by
         * @param {number} page Page to start on (defaults to 1)
         * @param {number} size Size of result set to return (defaults to 15)
         * @param {boolean} includeDeleted Include deleted tenancy orders
         * @param {boolean} onlyDeleted Filter for deleted items only
         * @param {string} [query] Search query
         * @param {'DRAFT' | 'PENDING' | 'COMPLETE' | 'CANCELLED' | 'REFUNDED'} [orderStatus] Order Status to filter by
         * @param {'ACTIVE' | 'CHECKED_OUT' | 'OVERDUE' | 'ENDING_SOON' | 'CLOSING_SOON'} [tenancyStatus] 
         * @param {'CREATED_AT' | 'START_DATE' | 'END_DATE'} [sortBy] Sort By to filter by
         * @param {'ASC' | 'DESC'} [sortDirection] 
         * @param {boolean} [letOnly] Filter for let only reposits
         * @param {boolean} [isNewTenancy] Filter for new tenancies
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        optimisedSearch(organizationId: string, page: number, size: number, includeDeleted: boolean, onlyDeleted: boolean, query?: string, orderStatus?: 'DRAFT' | 'PENDING' | 'COMPLETE' | 'CANCELLED' | 'REFUNDED', tenancyStatus?: 'ACTIVE' | 'CHECKED_OUT' | 'OVERDUE' | 'ENDING_SOON' | 'CLOSING_SOON', sortBy?: 'CREATED_AT' | 'START_DATE' | 'END_DATE', sortDirection?: 'ASC' | 'DESC', letOnly?: boolean, isNewTenancy?: boolean, options: any = {}): RequestArgs {
            // verify required parameter 'organizationId' is not null or undefined
            if (organizationId === null || organizationId === undefined) {
                throw new RequiredError('organizationId','Required parameter organizationId was null or undefined when calling optimisedSearch.');
            }
            // verify required parameter 'page' is not null or undefined
            if (page === null || page === undefined) {
                throw new RequiredError('page','Required parameter page was null or undefined when calling optimisedSearch.');
            }
            // verify required parameter 'size' is not null or undefined
            if (size === null || size === undefined) {
                throw new RequiredError('size','Required parameter size was null or undefined when calling optimisedSearch.');
            }
            // verify required parameter 'includeDeleted' is not null or undefined
            if (includeDeleted === null || includeDeleted === undefined) {
                throw new RequiredError('includeDeleted','Required parameter includeDeleted was null or undefined when calling optimisedSearch.');
            }
            // verify required parameter 'onlyDeleted' is not null or undefined
            if (onlyDeleted === null || onlyDeleted === undefined) {
                throw new RequiredError('onlyDeleted','Required parameter onlyDeleted was null or undefined when calling optimisedSearch.');
            }
            const localVarPath = `/v2/tenancy-orders/optimised-search`;
            const localVarUrlObj = new URL(localVarPath, 'http://placeholder');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (query !== undefined) {
                localVarQueryParameter['query'] = query;
            }

            if (organizationId !== undefined) {
                localVarQueryParameter['organizationId'] = organizationId;
            }

            if (orderStatus !== undefined) {
                localVarQueryParameter['orderStatus'] = orderStatus;
            }

            if (tenancyStatus !== undefined) {
                localVarQueryParameter['tenancyStatus'] = tenancyStatus;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }

            if (sortDirection !== undefined) {
                localVarQueryParameter['sortDirection'] = sortDirection;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (includeDeleted !== undefined) {
                localVarQueryParameter['includeDeleted'] = includeDeleted;
            }

            if (onlyDeleted !== undefined) {
                localVarQueryParameter['onlyDeleted'] = onlyDeleted;
            }

            if (letOnly !== undefined) {
                localVarQueryParameter['letOnly'] = letOnly;
            }

            if (isNewTenancy !== undefined) {
                localVarQueryParameter['isNewTenancy'] = isNewTenancy;
            }


    
            Object.entries({...localVarQueryParameter, ...options.query}).forEach(([key, value]) => {
                if (value !== undefined) {
                    localVarUrlObj.searchParams.set(key, String(value));
                }
            });
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search,
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete a Tenancy Order
         * @param {string} id Tenancy Order Id
         * @param {RemoveTenancyOrderDTO} removeTenancyOrderDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeTenancyOrderById(id: string, removeTenancyOrderDTO: RemoveTenancyOrderDTO, options: any = {}): RequestArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling removeTenancyOrderById.');
            }
            // verify required parameter 'removeTenancyOrderDTO' is not null or undefined
            if (removeTenancyOrderDTO === null || removeTenancyOrderDTO === undefined) {
                throw new RequiredError('removeTenancyOrderDTO','Required parameter removeTenancyOrderDTO was null or undefined when calling removeTenancyOrderById.');
            }
            const localVarPath = `/v2/tenancy-orders/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = new URL(localVarPath, 'http://placeholder');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            Object.entries({...localVarQueryParameter, ...options.query}).forEach(([key, value]) => {
                if (value !== undefined) {
                    localVarUrlObj.searchParams.set(key, String(value));
                }
            });
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};
            const needsSerialization = (<any>"RemoveTenancyOrderDTO" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(removeTenancyOrderDTO !== undefined ? removeTenancyOrderDTO : {}) : (removeTenancyOrderDTO || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search,
                options: localVarRequestOptions,
            };
        },
        /**
         * Reopen a closed tenancy order
         * @param {string} id Tenancy Order Id
         * @param {ReopenRepositDTO} reopenRepositDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reopenTenancyOrder(id: string, reopenRepositDTO: ReopenRepositDTO, options: any = {}): RequestArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling reopenTenancyOrder.');
            }
            // verify required parameter 'reopenRepositDTO' is not null or undefined
            if (reopenRepositDTO === null || reopenRepositDTO === undefined) {
                throw new RequiredError('reopenRepositDTO','Required parameter reopenRepositDTO was null or undefined when calling reopenTenancyOrder.');
            }
            const localVarPath = `/v2/tenancy-orders/{id}/reopen`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = new URL(localVarPath, 'http://placeholder');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            Object.entries({...localVarQueryParameter, ...options.query}).forEach(([key, value]) => {
                if (value !== undefined) {
                    localVarUrlObj.searchParams.set(key, String(value));
                }
            });
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};
            const needsSerialization = (<any>"ReopenRepositDTO" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(reopenRepositDTO !== undefined ? reopenRepositDTO : {}) : (reopenRepositDTO || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search,
                options: localVarRequestOptions,
            };
        },
        /**
         * Send overdue chasers to tenants
         * @param {string} id Tenancy Order Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendOverdueChasers(id: string, options: any = {}): RequestArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling sendOverdueChasers.');
            }
            const localVarPath = `/v2/tenancy-orders/{id}/send-overdue-chasers`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = new URL(localVarPath, 'http://placeholder');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            Object.entries({...localVarQueryParameter, ...options.query}).forEach(([key, value]) => {
                if (value !== undefined) {
                    localVarUrlObj.searchParams.set(key, String(value));
                }
            });
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search,
                options: localVarRequestOptions,
            };
        },
        /**
         * Transfer a Tenancy Order to a different Organization
         * @param {string} id Tenancy Order Id
         * @param {TransferTenancyOrderDTO} transferTenancyOrderDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        transferTenancyOrderToOrganization(id: string, transferTenancyOrderDTO: TransferTenancyOrderDTO, options: any = {}): RequestArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling transferTenancyOrderToOrganization.');
            }
            // verify required parameter 'transferTenancyOrderDTO' is not null or undefined
            if (transferTenancyOrderDTO === null || transferTenancyOrderDTO === undefined) {
                throw new RequiredError('transferTenancyOrderDTO','Required parameter transferTenancyOrderDTO was null or undefined when calling transferTenancyOrderToOrganization.');
            }
            const localVarPath = `/v2/tenancy-orders/{id}/transfer`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = new URL(localVarPath, 'http://placeholder');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            Object.entries({...localVarQueryParameter, ...options.query}).forEach(([key, value]) => {
                if (value !== undefined) {
                    localVarUrlObj.searchParams.set(key, String(value));
                }
            });
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};
            const needsSerialization = (<any>"TransferTenancyOrderDTO" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(transferTenancyOrderDTO !== undefined ? transferTenancyOrderDTO : {}) : (transferTenancyOrderDTO || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search,
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TenancyOrdersApi - functional programming interface
 * @export
 */
export const TenancyOrdersApiFp = function(configuration?: Configuration) {
    return {
        /**
         * Get a Tenancy Order By Id
         * @param {string} id Tenancy Order Id
         * @param {boolean} [includeDeleted] Include deleted
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTenancyOrderById(id: string, includeDeleted?: boolean, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<TenancyOrderWithTenancyAndOrderCustomersDTO> {
            const localVarAxiosArgs = TenancyOrdersApiAxiosParamCreator(configuration).getTenancyOrderById(id, includeDeleted, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Optimised search for a tenancy order via address, landlord and tenants
         * @param {string} organizationId Organization Id to filter to by
         * @param {number} page Page to start on (defaults to 1)
         * @param {number} size Size of result set to return (defaults to 15)
         * @param {boolean} includeDeleted Include deleted tenancy orders
         * @param {boolean} onlyDeleted Filter for deleted items only
         * @param {string} [query] Search query
         * @param {'DRAFT' | 'PENDING' | 'COMPLETE' | 'CANCELLED' | 'REFUNDED'} [orderStatus] Order Status to filter by
         * @param {'ACTIVE' | 'CHECKED_OUT' | 'OVERDUE' | 'ENDING_SOON' | 'CLOSING_SOON'} [tenancyStatus] 
         * @param {'CREATED_AT' | 'START_DATE' | 'END_DATE'} [sortBy] Sort By to filter by
         * @param {'ASC' | 'DESC'} [sortDirection] 
         * @param {boolean} [letOnly] Filter for let only reposits
         * @param {boolean} [isNewTenancy] Filter for new tenancies
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        optimisedSearch(organizationId: string, page: number, size: number, includeDeleted: boolean, onlyDeleted: boolean, query?: string, orderStatus?: 'DRAFT' | 'PENDING' | 'COMPLETE' | 'CANCELLED' | 'REFUNDED', tenancyStatus?: 'ACTIVE' | 'CHECKED_OUT' | 'OVERDUE' | 'ENDING_SOON' | 'CLOSING_SOON', sortBy?: 'CREATED_AT' | 'START_DATE' | 'END_DATE', sortDirection?: 'ASC' | 'DESC', letOnly?: boolean, isNewTenancy?: boolean, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<SearchTenancyOrderResultsDTO> {
            const localVarAxiosArgs = TenancyOrdersApiAxiosParamCreator(configuration).optimisedSearch(organizationId, page, size, includeDeleted, onlyDeleted, query, orderStatus, tenancyStatus, sortBy, sortDirection, letOnly, isNewTenancy, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Delete a Tenancy Order
         * @param {string} id Tenancy Order Id
         * @param {RemoveTenancyOrderDTO} removeTenancyOrderDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeTenancyOrderById(id: string, removeTenancyOrderDTO: RemoveTenancyOrderDTO, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<TenancyOrderWithTenancyAndOrderCustomersDTO> {
            const localVarAxiosArgs = TenancyOrdersApiAxiosParamCreator(configuration).removeTenancyOrderById(id, removeTenancyOrderDTO, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Reopen a closed tenancy order
         * @param {string} id Tenancy Order Id
         * @param {ReopenRepositDTO} reopenRepositDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reopenTenancyOrder(id: string, reopenRepositDTO: ReopenRepositDTO, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<TenancyOrderWithTenancyAndOrderCustomersDTO> {
            const localVarAxiosArgs = TenancyOrdersApiAxiosParamCreator(configuration).reopenTenancyOrder(id, reopenRepositDTO, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Send overdue chasers to tenants
         * @param {string} id Tenancy Order Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendOverdueChasers(id: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response> {
            const localVarAxiosArgs = TenancyOrdersApiAxiosParamCreator(configuration).sendOverdueChasers(id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Transfer a Tenancy Order to a different Organization
         * @param {string} id Tenancy Order Id
         * @param {TransferTenancyOrderDTO} transferTenancyOrderDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        transferTenancyOrderToOrganization(id: string, transferTenancyOrderDTO: TransferTenancyOrderDTO, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<TenancyOrderWithTenancyAndOrderCustomersDTO> {
            const localVarAxiosArgs = TenancyOrdersApiAxiosParamCreator(configuration).transferTenancyOrderToOrganization(id, transferTenancyOrderDTO, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * TenancyOrdersApi - factory interface
 * @export
 */
export const TenancyOrdersApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * Get a Tenancy Order By Id
         * @param {string} id Tenancy Order Id
         * @param {boolean} [includeDeleted] Include deleted
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTenancyOrderById(id: string, includeDeleted?: boolean, options?: any) {
            return TenancyOrdersApiFp(configuration).getTenancyOrderById(id, includeDeleted, options)(axios, basePath);
        },
        /**
         * Optimised search for a tenancy order via address, landlord and tenants
         * @param {string} organizationId Organization Id to filter to by
         * @param {number} page Page to start on (defaults to 1)
         * @param {number} size Size of result set to return (defaults to 15)
         * @param {boolean} includeDeleted Include deleted tenancy orders
         * @param {boolean} onlyDeleted Filter for deleted items only
         * @param {string} [query] Search query
         * @param {'DRAFT' | 'PENDING' | 'COMPLETE' | 'CANCELLED' | 'REFUNDED'} [orderStatus] Order Status to filter by
         * @param {'ACTIVE' | 'CHECKED_OUT' | 'OVERDUE' | 'ENDING_SOON' | 'CLOSING_SOON'} [tenancyStatus] 
         * @param {'CREATED_AT' | 'START_DATE' | 'END_DATE'} [sortBy] Sort By to filter by
         * @param {'ASC' | 'DESC'} [sortDirection] 
         * @param {boolean} [letOnly] Filter for let only reposits
         * @param {boolean} [isNewTenancy] Filter for new tenancies
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        optimisedSearch(organizationId: string, page: number, size: number, includeDeleted: boolean, onlyDeleted: boolean, query?: string, orderStatus?: 'DRAFT' | 'PENDING' | 'COMPLETE' | 'CANCELLED' | 'REFUNDED', tenancyStatus?: 'ACTIVE' | 'CHECKED_OUT' | 'OVERDUE' | 'ENDING_SOON' | 'CLOSING_SOON', sortBy?: 'CREATED_AT' | 'START_DATE' | 'END_DATE', sortDirection?: 'ASC' | 'DESC', letOnly?: boolean, isNewTenancy?: boolean, options?: any) {
            return TenancyOrdersApiFp(configuration).optimisedSearch(organizationId, page, size, includeDeleted, onlyDeleted, query, orderStatus, tenancyStatus, sortBy, sortDirection, letOnly, isNewTenancy, options)(axios, basePath);
        },
        /**
         * Delete a Tenancy Order
         * @param {string} id Tenancy Order Id
         * @param {RemoveTenancyOrderDTO} removeTenancyOrderDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeTenancyOrderById(id: string, removeTenancyOrderDTO: RemoveTenancyOrderDTO, options?: any) {
            return TenancyOrdersApiFp(configuration).removeTenancyOrderById(id, removeTenancyOrderDTO, options)(axios, basePath);
        },
        /**
         * Reopen a closed tenancy order
         * @param {string} id Tenancy Order Id
         * @param {ReopenRepositDTO} reopenRepositDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reopenTenancyOrder(id: string, reopenRepositDTO: ReopenRepositDTO, options?: any) {
            return TenancyOrdersApiFp(configuration).reopenTenancyOrder(id, reopenRepositDTO, options)(axios, basePath);
        },
        /**
         * Send overdue chasers to tenants
         * @param {string} id Tenancy Order Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendOverdueChasers(id: string, options?: any) {
            return TenancyOrdersApiFp(configuration).sendOverdueChasers(id, options)(axios, basePath);
        },
        /**
         * Transfer a Tenancy Order to a different Organization
         * @param {string} id Tenancy Order Id
         * @param {TransferTenancyOrderDTO} transferTenancyOrderDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        transferTenancyOrderToOrganization(id: string, transferTenancyOrderDTO: TransferTenancyOrderDTO, options?: any) {
            return TenancyOrdersApiFp(configuration).transferTenancyOrderToOrganization(id, transferTenancyOrderDTO, options)(axios, basePath);
        },
    };
};

/**
 * TenancyOrdersApi - interface
 * @export
 * @interface TenancyOrdersApi
 */
export interface TenancyOrdersApiInterface {
    /**
     * Get a Tenancy Order By Id
     * @param {string} id Tenancy Order Id
     * @param {boolean} [includeDeleted] Include deleted
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenancyOrdersApiInterface
     */
    getTenancyOrderById(id: string, includeDeleted?: boolean, options?: any): AxiosPromise<TenancyOrderWithTenancyAndOrderCustomersDTO>;

    /**
     * Optimised search for a tenancy order via address, landlord and tenants
     * @param {string} organizationId Organization Id to filter to by
     * @param {number} page Page to start on (defaults to 1)
     * @param {number} size Size of result set to return (defaults to 15)
     * @param {boolean} includeDeleted Include deleted tenancy orders
     * @param {boolean} onlyDeleted Filter for deleted items only
     * @param {string} [query] Search query
     * @param {'DRAFT' | 'PENDING' | 'COMPLETE' | 'CANCELLED' | 'REFUNDED'} [orderStatus] Order Status to filter by
     * @param {'ACTIVE' | 'CHECKED_OUT' | 'OVERDUE' | 'ENDING_SOON' | 'CLOSING_SOON'} [tenancyStatus] 
     * @param {'CREATED_AT' | 'START_DATE' | 'END_DATE'} [sortBy] Sort By to filter by
     * @param {'ASC' | 'DESC'} [sortDirection] 
     * @param {boolean} [letOnly] Filter for let only reposits
     * @param {boolean} [isNewTenancy] Filter for new tenancies
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenancyOrdersApiInterface
     */
    optimisedSearch(organizationId: string, page: number, size: number, includeDeleted: boolean, onlyDeleted: boolean, query?: string, orderStatus?: 'DRAFT' | 'PENDING' | 'COMPLETE' | 'CANCELLED' | 'REFUNDED', tenancyStatus?: 'ACTIVE' | 'CHECKED_OUT' | 'OVERDUE' | 'ENDING_SOON' | 'CLOSING_SOON', sortBy?: 'CREATED_AT' | 'START_DATE' | 'END_DATE', sortDirection?: 'ASC' | 'DESC', letOnly?: boolean, isNewTenancy?: boolean, options?: any): AxiosPromise<SearchTenancyOrderResultsDTO>;

    /**
     * Delete a Tenancy Order
     * @param {string} id Tenancy Order Id
     * @param {RemoveTenancyOrderDTO} removeTenancyOrderDTO 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenancyOrdersApiInterface
     */
    removeTenancyOrderById(id: string, removeTenancyOrderDTO: RemoveTenancyOrderDTO, options?: any): AxiosPromise<TenancyOrderWithTenancyAndOrderCustomersDTO>;

    /**
     * Reopen a closed tenancy order
     * @param {string} id Tenancy Order Id
     * @param {ReopenRepositDTO} reopenRepositDTO 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenancyOrdersApiInterface
     */
    reopenTenancyOrder(id: string, reopenRepositDTO: ReopenRepositDTO, options?: any): AxiosPromise<TenancyOrderWithTenancyAndOrderCustomersDTO>;

    /**
     * Send overdue chasers to tenants
     * @param {string} id Tenancy Order Id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenancyOrdersApiInterface
     */
    sendOverdueChasers(id: string, options?: any): AxiosPromise<{}>;

    /**
     * Transfer a Tenancy Order to a different Organization
     * @param {string} id Tenancy Order Id
     * @param {TransferTenancyOrderDTO} transferTenancyOrderDTO 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenancyOrdersApiInterface
     */
    transferTenancyOrderToOrganization(id: string, transferTenancyOrderDTO: TransferTenancyOrderDTO, options?: any): AxiosPromise<TenancyOrderWithTenancyAndOrderCustomersDTO>;

}

/**
 * TenancyOrdersApi - object-oriented interface
 * @export
 * @class TenancyOrdersApi
 * @extends {BaseAPI}
 */
export class TenancyOrdersApi extends BaseAPI implements TenancyOrdersApiInterface {
    /**
     * Get a Tenancy Order By Id
     * @param {string} id Tenancy Order Id
     * @param {boolean} [includeDeleted] Include deleted
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenancyOrdersApi
     */
    public getTenancyOrderById(id: string, includeDeleted?: boolean, options?: any) {
        return TenancyOrdersApiFp(this.configuration).getTenancyOrderById(id, includeDeleted, options)(this.axios, this.basePath);
    }

    /**
     * Optimised search for a tenancy order via address, landlord and tenants
     * @param {string} organizationId Organization Id to filter to by
     * @param {number} page Page to start on (defaults to 1)
     * @param {number} size Size of result set to return (defaults to 15)
     * @param {boolean} includeDeleted Include deleted tenancy orders
     * @param {boolean} onlyDeleted Filter for deleted items only
     * @param {string} [query] Search query
     * @param {'DRAFT' | 'PENDING' | 'COMPLETE' | 'CANCELLED' | 'REFUNDED'} [orderStatus] Order Status to filter by
     * @param {'ACTIVE' | 'CHECKED_OUT' | 'OVERDUE' | 'ENDING_SOON' | 'CLOSING_SOON'} [tenancyStatus] 
     * @param {'CREATED_AT' | 'START_DATE' | 'END_DATE'} [sortBy] Sort By to filter by
     * @param {'ASC' | 'DESC'} [sortDirection] 
     * @param {boolean} [letOnly] Filter for let only reposits
     * @param {boolean} [isNewTenancy] Filter for new tenancies
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenancyOrdersApi
     */
    public optimisedSearch(organizationId: string, page: number, size: number, includeDeleted: boolean, onlyDeleted: boolean, query?: string, orderStatus?: 'DRAFT' | 'PENDING' | 'COMPLETE' | 'CANCELLED' | 'REFUNDED', tenancyStatus?: 'ACTIVE' | 'CHECKED_OUT' | 'OVERDUE' | 'ENDING_SOON' | 'CLOSING_SOON', sortBy?: 'CREATED_AT' | 'START_DATE' | 'END_DATE', sortDirection?: 'ASC' | 'DESC', letOnly?: boolean, isNewTenancy?: boolean, options?: any) {
        return TenancyOrdersApiFp(this.configuration).optimisedSearch(organizationId, page, size, includeDeleted, onlyDeleted, query, orderStatus, tenancyStatus, sortBy, sortDirection, letOnly, isNewTenancy, options)(this.axios, this.basePath);
    }

    /**
     * Delete a Tenancy Order
     * @param {string} id Tenancy Order Id
     * @param {RemoveTenancyOrderDTO} removeTenancyOrderDTO 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenancyOrdersApi
     */
    public removeTenancyOrderById(id: string, removeTenancyOrderDTO: RemoveTenancyOrderDTO, options?: any) {
        return TenancyOrdersApiFp(this.configuration).removeTenancyOrderById(id, removeTenancyOrderDTO, options)(this.axios, this.basePath);
    }

    /**
     * Reopen a closed tenancy order
     * @param {string} id Tenancy Order Id
     * @param {ReopenRepositDTO} reopenRepositDTO 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenancyOrdersApi
     */
    public reopenTenancyOrder(id: string, reopenRepositDTO: ReopenRepositDTO, options?: any) {
        return TenancyOrdersApiFp(this.configuration).reopenTenancyOrder(id, reopenRepositDTO, options)(this.axios, this.basePath);
    }

    /**
     * Send overdue chasers to tenants
     * @param {string} id Tenancy Order Id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenancyOrdersApi
     */
    public sendOverdueChasers(id: string, options?: any) {
        return TenancyOrdersApiFp(this.configuration).sendOverdueChasers(id, options)(this.axios, this.basePath);
    }

    /**
     * Transfer a Tenancy Order to a different Organization
     * @param {string} id Tenancy Order Id
     * @param {TransferTenancyOrderDTO} transferTenancyOrderDTO 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenancyOrdersApi
     */
    public transferTenancyOrderToOrganization(id: string, transferTenancyOrderDTO: TransferTenancyOrderDTO, options?: any) {
        return TenancyOrdersApiFp(this.configuration).transferTenancyOrderToOrganization(id, transferTenancyOrderDTO, options)(this.axios, this.basePath);
    }

}

/**
 * Standalone tree-shakeable functions for TenancyOrdersApi
 * Import individual functions for optimal bundle size
 */
/**
 * Get a Tenancy Order By Id
 * @param {string} id Tenancy Order Id
 * @param {boolean} [includeDeleted] Include deleted
 * @param {Configuration} [configuration] Optional configuration
 * @param {AxiosInstance} [axios] Optional axios instance
 * @param {string} [basePath] Optional base path
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
export async function getTenancyOrderById(
    id: string,
    includeDeleted?: boolean,
    configuration?: Configuration,
    axios: AxiosInstance = globalAxios,
    basePath: string = BASE_PATH,
    options?: any
): Promise<TenancyOrderWithTenancyAndOrderCustomersDTO> {
    const localVarAxiosArgs = TenancyOrdersApiAxiosParamCreator(configuration).getTenancyOrderById(id, includeDeleted, options);
    const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
    const __response = await axios.request(axiosRequestArgs);
    return __response.data;
}

/**
 * Optimised search for a tenancy order via address, landlord and tenants
 * @param {string} organizationId Organization Id to filter to by
 * @param {number} page Page to start on (defaults to 1)
 * @param {number} size Size of result set to return (defaults to 15)
 * @param {boolean} includeDeleted Include deleted tenancy orders
 * @param {boolean} onlyDeleted Filter for deleted items only
 * @param {string} [query] Search query
 * @param {'DRAFT' | 'PENDING' | 'COMPLETE' | 'CANCELLED' | 'REFUNDED'} [orderStatus] Order Status to filter by
 * @param {'ACTIVE' | 'CHECKED_OUT' | 'OVERDUE' | 'ENDING_SOON' | 'CLOSING_SOON'} [tenancyStatus] 
 * @param {'CREATED_AT' | 'START_DATE' | 'END_DATE'} [sortBy] Sort By to filter by
 * @param {'ASC' | 'DESC'} [sortDirection] 
 * @param {boolean} [letOnly] Filter for let only reposits
 * @param {boolean} [isNewTenancy] Filter for new tenancies
 * @param {Configuration} [configuration] Optional configuration
 * @param {AxiosInstance} [axios] Optional axios instance
 * @param {string} [basePath] Optional base path
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
export async function optimisedSearch(
    organizationId: string,
    page: number,
    size: number,
    includeDeleted: boolean,
    onlyDeleted: boolean,
    query?: string,
    orderStatus?: 'DRAFT' | 'PENDING' | 'COMPLETE' | 'CANCELLED' | 'REFUNDED',
    tenancyStatus?: 'ACTIVE' | 'CHECKED_OUT' | 'OVERDUE' | 'ENDING_SOON' | 'CLOSING_SOON',
    sortBy?: 'CREATED_AT' | 'START_DATE' | 'END_DATE',
    sortDirection?: 'ASC' | 'DESC',
    letOnly?: boolean,
    isNewTenancy?: boolean,
    configuration?: Configuration,
    axios: AxiosInstance = globalAxios,
    basePath: string = BASE_PATH,
    options?: any
): Promise<SearchTenancyOrderResultsDTO> {
    const localVarAxiosArgs = TenancyOrdersApiAxiosParamCreator(configuration).optimisedSearch(organizationId, page, size, includeDeleted, onlyDeleted, query, orderStatus, tenancyStatus, sortBy, sortDirection, letOnly, isNewTenancy, options);
    const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
    const __response = await axios.request(axiosRequestArgs);
    return __response.data;
}

/**
 * Delete a Tenancy Order
 * @param {string} id Tenancy Order Id
 * @param {RemoveTenancyOrderDTO} removeTenancyOrderDTO 
 * @param {Configuration} [configuration] Optional configuration
 * @param {AxiosInstance} [axios] Optional axios instance
 * @param {string} [basePath] Optional base path
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
export async function removeTenancyOrderById(
    id: string,
    removeTenancyOrderDTO: RemoveTenancyOrderDTO,
    configuration?: Configuration,
    axios: AxiosInstance = globalAxios,
    basePath: string = BASE_PATH,
    options?: any
): Promise<TenancyOrderWithTenancyAndOrderCustomersDTO> {
    const localVarAxiosArgs = TenancyOrdersApiAxiosParamCreator(configuration).removeTenancyOrderById(id, removeTenancyOrderDTO, options);
    const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
    const __response = await axios.request(axiosRequestArgs);
    return __response.data;
}

/**
 * Reopen a closed tenancy order
 * @param {string} id Tenancy Order Id
 * @param {ReopenRepositDTO} reopenRepositDTO 
 * @param {Configuration} [configuration] Optional configuration
 * @param {AxiosInstance} [axios] Optional axios instance
 * @param {string} [basePath] Optional base path
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
export async function reopenTenancyOrder(
    id: string,
    reopenRepositDTO: ReopenRepositDTO,
    configuration?: Configuration,
    axios: AxiosInstance = globalAxios,
    basePath: string = BASE_PATH,
    options?: any
): Promise<TenancyOrderWithTenancyAndOrderCustomersDTO> {
    const localVarAxiosArgs = TenancyOrdersApiAxiosParamCreator(configuration).reopenTenancyOrder(id, reopenRepositDTO, options);
    const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
    const __response = await axios.request(axiosRequestArgs);
    return __response.data;
}

/**
 * Send overdue chasers to tenants
 * @param {string} id Tenancy Order Id
 * @param {Configuration} [configuration] Optional configuration
 * @param {AxiosInstance} [axios] Optional axios instance
 * @param {string} [basePath] Optional base path
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
export async function sendOverdueChasers(
    id: string,
    configuration?: Configuration,
    axios: AxiosInstance = globalAxios,
    basePath: string = BASE_PATH,
    options?: any
): Promise<void> {
    const localVarAxiosArgs = TenancyOrdersApiAxiosParamCreator(configuration).sendOverdueChasers(id, options);
    const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
    const __response = await axios.request(axiosRequestArgs);
    return __response.data;
}

/**
 * Transfer a Tenancy Order to a different Organization
 * @param {string} id Tenancy Order Id
 * @param {TransferTenancyOrderDTO} transferTenancyOrderDTO 
 * @param {Configuration} [configuration] Optional configuration
 * @param {AxiosInstance} [axios] Optional axios instance
 * @param {string} [basePath] Optional base path
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
export async function transferTenancyOrderToOrganization(
    id: string,
    transferTenancyOrderDTO: TransferTenancyOrderDTO,
    configuration?: Configuration,
    axios: AxiosInstance = globalAxios,
    basePath: string = BASE_PATH,
    options?: any
): Promise<TenancyOrderWithTenancyAndOrderCustomersDTO> {
    const localVarAxiosArgs = TenancyOrdersApiAxiosParamCreator(configuration).transferTenancyOrderToOrganization(id, transferTenancyOrderDTO, options);
    const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
    const __response = await axios.request(axiosRequestArgs);
    return __response.data;
}

